export default __webpack_public_path__ + "app/images/4b9dd7a3a51aba87a810bd4ad76f98ea.png";